$('.home_ban').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
   prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0675/5162/5294/files/back_1.png?v=1756878640'></button>",
   nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0675/5162/5294/files/right-arrow_2.png?v=1756878640'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



$('.hoe_feat').slick({
  centerMode: true,
  dots: false,
  arrows:true,
  centerPadding: '0px',
  slidesToShow: 3,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0675/5162/5294/files/back_1.png?v=1756878640'></button>",
   nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0675/5162/5294/files/right-arrow_2.png?v=1756878640'></button>",
  responsive: [
    {
      breakpoint: 989,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 2
      }
    },
    {
      breakpoint: 749,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        slidesToShow: 1
      }
    }
  ]
});



$(document).ready(function () {
  var $slider = $(".home__large_ban");

  // Initialize slick
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
     speed: 500,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    autoplay: false
  });

  // Custom prev/next buttons
  $(".prev-btn").click(function () {
    $slider.slick("slickPrev");
  });

  $(".next-btn").click(function () {
    $slider.slick("slickNext");
  });

  // Set total counter
  var totalSlides = $slider.find(".slick-slide").not(".slick-cloned").length;
  $(".slide-counter-total").text(totalSlides);

  // Initial counter and disable prev button
  $(".slide-counter-current").text(1);
  $(".prev-btn").addClass("slick-disabled");

  // Update on change
  $slider.on("afterChange", function (event, slick, currentSlide) {
    let current = currentSlide + 1;
    $(".slide-counter-current").text(current);

    // Handle button disabling
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
    } else {
      $(".prev-btn").removeClass("slick-disabled");
    }

    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
    } else {
      $(".next-btn").removeClass("slick-disabled");
    }
  });
});




$('.testi_slider').slick({
  infinite: true,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1
});






            $(document).ready(function() {
        var $slider = $('.slider1');
        var $progressBar = $('.progress');
        var $progressBarLabel = $( '.slider__label' );

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

          $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );

          $progressBarLabel.text( calc + '% completed' );
        });

        $slider.slick({
          slidesToShow: 1,
          autoplay: true,
          arrows: false,
           centerMode: true,
          centerPadding: '600px',
         autoplaySpeed: 8000,
          slidesToScroll: 1,
          speed: 400,
           prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0577/3583/9949/files/left.png?v=1710853922'></button>",
          nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0577/3583/9949/files/next_1.png?v=1710853922'></button>",
           responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 1,
              centerPadding: '100px',
              slidesToScroll: 1
            }
          },
               {
            breakpoint: 989,
            settings: {
              slidesToShow: 1,
              centerPadding: '100px',
              slidesToScroll: 1
            }
          },
           {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
              centerPadding: '50px',
              slidesToScroll: 1
            }
          }
   
        ]
        });
      });

// $('.responsivenew').slick({
//   dots: false,
//   infinite: true,
//   speed: 500, // smoother transition
//   cssEase: 'ease-in-out',
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   prevArrow: `
//     <button type="button" class="slick-prev" aria-label="Previous">
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//         <path d="M15 18L9 12L15 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//       </svg>
//     </button>
//   `,
//   nextArrow: `
//     <button type="button" class="slick-next" aria-label="Next">
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
//         <path d="M9 6L15 12L9 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//       </svg>
//     </button>
//   `,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
